// extracted by mini-css-extract-plugin
export default {"root":"ButtonBase_root__dhE79","disabled":"ButtonBase_disabled__MaZUB","icon":"ButtonBase_icon__NCBYp"};